import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { viewDoc } from '../../services/api/admin';
import { GetLocalStorageParsed } from '../../Utils/Utils';
import html2canvas from 'html2canvas'; // Import html2canvas
//import * as XLSX from 'xlsx'; // For Excel file handling
//import mammoth from 'mammoth'; // For DOCX handling

const DocsViewer = () => {
  const { folder1, folder2, folder3, fileName } = useParams();
  var userDetail = GetLocalStorageParsed("userDetail") || {};

  const [docUrl, setDocUrl] = useState(null); // State to hold PDF Blob URL
  const [loading, setLoading] = useState(true); // To show loading state
  const [error, setError] = useState(null); // For error handling
  const [fileContent, setFileContent] = useState(null); // For storing file content like images or text
  const [fileType, setFileType] = useState(null); // To store the file type

  useEffect(() => {
    const fetchDoc = async () => {
      try {
        const formData = new FormData();
        formData.append("district_id", userDetail?.roles === " admin" ? userDetail?.district ?? "" : "");
        const response = await viewDoc(
          fileName,
          folder1,
          folder2,
          folder3 ?? "null",
          formData
        );

        if (response) {
          const fileExt = fileName?.split('.').pop()?.toLowerCase();
          setFileType(fileExt);

          // Handling different file types
          if (fileExt === 'pdf') {
            const blob = new Blob([response], { type: 'application/pdf' });
            const pdfBlobUrl = URL.createObjectURL(blob);
            setDocUrl(pdfBlobUrl);
          } else if (['jpg', 'jpeg', 'png'].includes(fileExt)) {
            // For image files, display them
            const blob = new Blob([response], { type: `image/${fileExt}` });
            const imageUrl = URL.createObjectURL(blob);
            setFileContent(imageUrl);
          } else if (fileExt === 'txt') {
            // For text files, display them as text
            const text = await response.text();
            setFileContent(text);
          } 
        //   else if (fileExt === 'csv') {
        //     // For CSV files, parse them
        //     const text = await response.text();
        //     setFileContent(text);
        //   } else if (fileExt === 'xlsx' || fileExt === 'xls') {
        //     // For Excel files, parse them
        //     const data = new Uint8Array(await response.arrayBuffer());
        //     const workbook = XLSX.read(data, { type: 'array' });
        //     const sheetName = workbook.SheetNames[0]; // Assuming first sheet for now
        //     const sheet = workbook.Sheets[sheetName];
        //     const json = XLSX.utils.sheet_to_json(sheet, { header: 1 });
        //     setFileContent(json);
        //   }
           else if (fileExt === 'ppt' || fileExt === 'pptx') {
            // For PPT files, might need external libraries for full support
            setError("PPT files are not supported yet.");
          } 
        //   else if (fileExt === 'docx') {
        //     // For DOCX files, convert them to HTML using Mammoth
        //     const arrayBuffer = await response.arrayBuffer();
        //     mammoth.convertToHtml({ arrayBuffer })
        //       .then((result) => {
        //         setFileContent(result.value); // The converted HTML content
        //       })
        //       .catch((err) => {
        //         setError("Error processing DOCX file.");
        //       });
        //   }
           else {
            setError("Unsupported file type.");
          }
        }
      } catch (err) {
        setError("Error fetching the file");
      } finally {
        setLoading(false); // Set loading state to false when finished
      }
    };

    if (fileName) {
      fetchDoc();
    }
  }, [fileName]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey && event.key === "s") {
        event.preventDefault(); // Prevent the default browser save behavior
        if (fileType && fileContent) {
          // Only trigger the save if fileContent and fileType are available
          if (['jpg', 'jpeg', 'png'].includes(fileType)) {
            saveImageAsPng(fileContent); // Trigger the image download
          }
        }
      }
    };

    // Add event listener on mount
    window.addEventListener("keydown", handleKeyDown);

    // Clean up event listener on unmount
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [fileType, fileContent]); 

  const saveImageAsPng = (imageUrl) => {
    // Create an image element and set the source to the fileContent (image URL)
    const img = new Image();
    img.src = imageUrl;

    // Wait for the image to load
    img.onload = () => {
      // Create a canvas to draw the image onto
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      // Set canvas dimensions to match the image
      canvas.width = img.width;
      canvas.height = img.height;

      // Draw the image onto the canvas
      ctx.drawImage(img, 0, 0);

      // Convert the canvas to a data URL (PNG)
      const dataUrl = canvas.toDataURL("image/png");

      // Create a link element to trigger the download
      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = `${fileName.split('.')[0]}.png`; // Use the original filename with .png extension
      link.click(); // Trigger the download
    };
  };

  if (loading) {
    return <div></div>;
  }

  if (error) {
    return <div></div>;
  }

  // Display content based on the file type
  if (fileType === 'pdf' && docUrl) {
    return (
      <div>
        <object
          data={docUrl}
          type="application/pdf"
          width="100%"
          height="100vh"
          style={{ minHeight: "100vh" }}
        ></object>
      </div>
    );
  }
  if (['jpg', 'jpeg', 'png'].includes(fileType) && fileContent) {
    return (
        <div 
          style={{
            margin: 0,
            padding: 0,
            height: '100vh',  // Full viewport height
            backgroundColor: 'rgb(14, 14, 14)',  // Dark background color
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'hidden'  // Ensures no scrollbars appear
          }}
        >
          <img
            src={fileContent}
            alt="Document"
            style={{ display: 'block', WebkitUserSelect: 'none', margin: 'auto' , backgroundColor: 'hsl(0, 0%, 90%)', transition: 'background-color 300ms'}}
          />
        </div>
      );
  }

  if (fileType === 'txt' && fileContent) {
    return (
      <div>
        <pre>{fileContent}</pre>
      </div>
    );
  }

  if (fileType === 'csv' && fileContent) {
    return (
      <div>
        <pre>{fileContent}</pre>
      </div>
    );
  }

//   if ((fileType === 'xlsx' || fileType === 'xls') && fileContent) {
//     return (
//       <div>
//         <table>
//           <thead>
//             <tr>
//               {fileContent[0].map((header, index) => (
//                 <th key={index}>{header}</th>
//               ))}
//             </tr>
//           </thead>
//           <tbody>
//             {fileContent.slice(1).map((row, rowIndex) => (
//               <tr key={rowIndex}>
//                 {row.map((cell, cellIndex) => (
//                   <td key={cellIndex}>{cell}</td>
//                 ))}
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     );
//   }

//   if (fileType === 'docx' && fileContent) {
//     return (
//       <div
//         dangerouslySetInnerHTML={{
//           __html: fileContent, // Render the HTML content from DOCX
//         }}
//       />
//     );
//   }

  return <div>Unsupported file type or error occurred.</div>;
};

export default DocsViewer;
